import { ReactNode } from 'react';
import Layout from '../../common/Layout/Layout';
import styles from './AuthoringMessage.module.scss';

const AuthoringMessage = ({ children }: { children: ReactNode }) => (
  <Layout className={styles.container}>{children}</Layout>
);

export default AuthoringMessage;
